import EmailAddress from "common/values/email-address/email-address";
import Guid from "common/values/guid/guid";
import Name, { NameJSON } from "common/values/name/name";
import NetworkDomain from "common/values/network-domain/network-domain";
import UserOpenEntityAgreement from "legal-entities/entities/entity-agreement/user-open-entity-agreement";
import EntityName from "legal-entities/values/entity-name/entity-name";

export interface EntityAgreementJSON {
  id: string;
  entityName: string;
  administratorName?: NameJSON;
  administratorEmail?: string;
  termsFileId?: string;
  networkDomains?: string[];
}

export default class EntityAgreement {
  public readonly id: Guid;
  public readonly entityName: EntityName;
  public administratorName?: Name;
  public administratorEmail?: EmailAddress;
  public termsFileId?: Guid;
  public networkDomains?: NetworkDomain[];

  constructor(id: Guid, entityName: EntityName) {
    this.id = id;
    this.entityName = entityName;
  }

  static fromUserOpenEntityAgreement(userOpenEntityAgreement: UserOpenEntityAgreement) {
    return new EntityAgreement(userOpenEntityAgreement.id, userOpenEntityAgreement.entityName);
  }

  static fromJSON(json: EntityAgreementJSON): EntityAgreement {
    const { id, entityName, administratorName, administratorEmail, termsFileId } = json;
    const agreementId = Guid.fromJSON(id);
    if (!agreementId) {
      throw new Error("Invalid or missing id");
    }
    const agreement = new EntityAgreement(agreementId, EntityName.fromJSON(entityName));
    agreement.administratorName = administratorName ? Name.fromJSON(administratorName) : undefined;
    agreement.administratorEmail = administratorEmail ? EmailAddress.fromJSON(administratorEmail) : undefined;
    agreement.termsFileId = termsFileId ? Guid.fromJSON(termsFileId) : undefined;
    agreement.networkDomains = json.networkDomains ? json.networkDomains.map(domain => new NetworkDomain(domain)) : undefined;
    return agreement;
  }

  public toJSON() {
    return {
      id: this.id.toJSON(),
      entityName: this.entityName.toJSON(),
      administratorName: this.administratorName?.toJSON(),
      administratorEmail: this.administratorEmail?.toJSON(),
      termsFileId: this.termsFileId?.toJSON(),
      networkDomains: this.networkDomains?.map(domain => domain.value),
    };
  }
}
